module.exports = __webpack_public_path__ + "static/media/weiss_dimaggio.1bae9907.gif";